// extracted by mini-css-extract-plugin
export var collapsedSummary = "_se-0";